export function identityLabel(countryId, fallback = 'RFC') {
    return String(countryId) === '5' ? 'Tax ID' : fallback;
}
